// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--a1500";
export var content = "banner-module--content--823cf";
export var link = "banner-module--link--b7099";
export var text = "banner-module--text--866eb";